module.exports = __webpack_public_path__ + "static/grafika2-27004ffa5a262c609236e96a0e57d5f9.png";